import { render, staticRenderFns } from "./MatchNoneCDC.vue?vue&type=template&id=c3e8f978&"
import script from "./MatchNoneCDC.vue?vue&type=script&lang=ts&"
export * from "./MatchNoneCDC.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports